import { render, staticRenderFns } from "./DebitPaymentView.vue?vue&type=template&id=fff9d8f4&scoped=true&"
import script from "./DebitPaymentView.vue?vue&type=script&lang=ts&"
export * from "./DebitPaymentView.vue?vue&type=script&lang=ts&"
import style0 from "./DebitPaymentView.vue?vue&type=style&index=0&id=fff9d8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff9d8f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VSheet,VTooltip})
